module.exports = __webpack_public_path__ + "files/6a7055ed4e8114ea3151a6b095483789.png";